import { Card, Stat } from "@chakra-ui/react";
import { formatCurrency, formatNumber, isCurrencyColumn } from "../../lib/formatters";

interface MetricCardProps {
  title: string;
  value: string | number;
  config?: {
    prefix?: string;
    suffix?: string;
    decimals?: number;
    value_key?: string;
  };
}

export const MetricCard = ({ title, value, config }: MetricCardProps) => {
  const formatValue = () => {
    // Handle null/undefined values
    if (value === null || value === undefined) {
      return "—";
    }

    const prefix = config?.prefix || "";
    const suffix = config?.suffix || "";
    
    // If it's a number, apply smart formatting
    if (typeof value === "number") {
      // Check if it's a currency/revenue field
      const columnName = config?.value_key || title;
      const isCurrency = isCurrencyColumn(columnName);
      
      let formattedValue: string;
      if (isCurrency) {
        // Format as currency with commas
        formattedValue = formatCurrency(value, prefix || "₦", config?.decimals ?? 2);
        return suffix ? `${formattedValue}${suffix}` : formattedValue;
      } else {
        // Format as regular number with commas
        formattedValue = formatNumber(value, config?.decimals);
        return `${prefix}${formattedValue}${suffix}`;
      }
    }
    
    return `${prefix}${value}${suffix}`;
  };

  return (
    <Card.Root className="p-6!">
      <Stat.Root>
        <Stat.Label className="text-gray-600! text-sm! mb-2!">{title}</Stat.Label>
        <Stat.ValueText className="text-3xl! font-bold! text-[#0142B1]!">
          {formatValue()}
        </Stat.ValueText>
      </Stat.Root>
    </Card.Root>
  );
};
